// TODO: React specific imports
import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import
  styled
from 'styled-components';

// TODO: Vodacom internal imports
import {
  ColorSvg,
  HContainer,
  HFillContainerV,
  Text
} from '@vodacom/web-common';

import {
  SecondaryButton
} from 'components';

import {
  CustomColors,
  Icons
} from '../../../../constants';

const Card = styled(HContainer)`
  p {
    margin: 0
  }
`;

// TODO: Better name
export const BannerCard = (props) => {

  // TODO: Update render function
  const renderContent = () => {

    return (

      <Card
        backgroundColor={CustomColors.Blue2}
        width={'100%'}
        position={'relative'}>

        <HFillContainerV
          maxWidth={'100vw'}
          boxSizing={'border-box'}
          padding={'16px 16px'}>

            <Text
              fontSize={props.fontSize}
              padding={'0 6px'}
              color={CustomColors.White}dangerouslySetInnerHTML={{
                __html: props.text
              }} />

          <SecondaryButton
            margin={'0 28px 0 auto'}
            padding={'0'}
            fontSize='12px'
            activeBorderColor={CustomColors.White}
            activeBackgroundColor={CustomColors.Blue2}
            textColor={CustomColors.White}
            height={'40px'}
            maxHeight={'40px'}
            minHeight={'40px'}
            minWidth={'90px'}
            maxWidth={'90px'}
            width={'90px'}
            onClick={props.onClick}
            text='How it works'/>

          <HContainer
            position={'absolute'}
            top={'8px'}
            right={'8px'}>

            <ColorSvg
              src={Icons.Close}
              color={CustomColors.White}
              width={'16px'}
              height={'16px'}
              onClick={props.onClose}/>
          </HContainer>

        </HFillContainerV>

      </Card>
    );
  };

  return (

    renderContent()
  );
};

// TODO: Add proptypes
BannerCard.propTypes = {
  padding: PropTypes.string
};

// TODO: Add default props
BannerCard.defaultProps = {

};
